import { WarningDialog } from '@shared/components/WarningDialog/WarningDialog';

interface LeavePlanSetupDialogProps {
  open: boolean;
  onLeave: () => void;
  onContinue: () => void;
}

export const LeavePlanSetupDialog = ({ open, onLeave, onContinue }: LeavePlanSetupDialogProps) => (
  <WarningDialog
    open={open}
    title="Leave Plan Setup?"
    description="It looks like you're still setting up your plan. If you leave now, it won't be added to your cart and your selections won't be saved."
    outlinedButtonText="Leave Without saving"
    containedButtonText="Continue Editing"
    onOutlinedClick={onLeave}
    onContainedClick={onContinue}
    onClose={onContinue}
  />
);
